/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";

import styles from "assets/jss/material-dashboard-pro-react/components/footerStyle";

import { translate } from "functions/"

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const { fluid, white, rtlActive } = props;
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  });
  var anchor =
    classes.a +
    cx({
      [" " + classes.whiteColor]: white
    });
  var block = cx({
    [classes.block]: true,
    [classes.whiteColor]: white
  });
  return (
    <footer className={classes.footer}>
      <div className={container} style={{
        display: "flex",
        justifyContent: "center"
      }}>
        <p className={classes.center}>
          &copy; {1900 + new Date().getYear()}{" "}
          <a
            href="https://sonne.global"
            className={anchor}
            target="_blank" rel="noopener noreferrer"
          >
            {"SONNE GLOBAL"}
          </a>
          {` | ${translate("$__footerDescription", 1) !== '$__footerDescription' ? translate("$__footerDescription", 1) : ``}`}
        </p>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool
};
